import React from 'react';

import { HighlightableStringView } from '@/app/log-viewer/highlighting/HighlightableStringView';

import { FileDividerRowModel } from './FileDividerRowModel';

interface Props {
  model: FileDividerRowModel;
}

export function FileDividerRow({ model }: Props) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '6px 12px',
        background: 'linear-gradient(90deg, #e8f0fe 0%, #f1f3ff 100%)',
        borderTop: '2px solid #4285f4',
        borderBottom: '2px solid #4285f4',
        gap: 8,
        userSelect: 'none',
      }}
    >
      <span
        style={{
          fontSize: '0.7rem',
          color: '#1a56db',
          fontWeight: 700,
          fontFamily: 'var(--font-family)',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        }}
      >
        📂 File:
      </span>
      <span
        style={{
          fontSize: '0.75rem',
          color: '#1e3a6e',
          fontFamily: 'monospace',
          fontWeight: 600,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        <HighlightableStringView string={model.data.fileName} />
      </span>
    </div>
  );
}
